import { useBlockProps, RichText } from "@wordpress/block-editor";
import { InnerBlocks } from "@wordpress/block-editor";

export default function Save({ attributes }) {
  const { header, iconOpen, iconClose, style } = attributes;

  const {
    headerActiveColor,
    activeBackground,
    headerActiveTypography,
    activeBorder,
    activeShadow,
  } = style;

  const blockProps = useBlockProps.save({
    className:
      "brandy-collapsible " +
      (activeBackground?.slug !== ""
        ? `has-${activeBackground?.slug}-active-background-color`
        : activeBackground?.color !== ""
        ? "has-active-background-color"
        : "") +
      " " +
      (headerActiveColor?.slug !== ""
        ? `has-${headerActiveColor?.slug}-header-active-color`
        : headerActiveColor?.color !== ""
        ? "has-header-active-color"
        : ""),
    style: {
      "--header-active-color":
        headerActiveColor &&
        (headerActiveColor?.slug !== ""
          ? `var(--wp--preset--color--${headerActiveColor?.slug})`
          : headerActiveColor?.color),
      "--header-active-font-size": headerActiveTypography?.fontSize,
      "--header-active-font-weight": headerActiveTypography?.fontWeight,
      "--header-active-text-transform": headerActiveTypography?.textTransform,
      ...(activeBorder
        ? {
            "--active-border-style": activeBorder?.style,
            "--active-border-width": activeBorder?.width,
            "--active-border-color": activeBorder?.color,
          }
        : {}),
      "--active-shadow": activeShadow,
      "--active-background":
        activeBackground &&
        (activeBackground?.slug !== ""
          ? `var(--wp--preset--color--${activeBackground?.slug})`
          : activeBackground?.color),
    },
  });

  return (
    <details
      {...blockProps}
      data-icon-open={iconOpen}
      data-icon-close={iconClose}
    >
      <summary
        data-header-active-typography={JSON.stringify(headerActiveTypography)}
      >
        <RichText.Content tagName="span" value={header} />
        <span className="collapsible-icon open-icon">
          <i className={`ph ph-${iconOpen}`}></i>
        </span>
        <span className="collapsible-icon close-icon">
          <i className={`ph ph-${iconClose}`}></i>
        </span>
      </summary>
      <div className="collapsible-content">
        <InnerBlocks.Content />
      </div>
    </details>
  );
}
